import { Component, type ErrorInfo, type ReactNode } from 'react'

type Props = { children: ReactNode }
type State = { error: Error | null }

export default class PlannerErrorBoundary extends Component<Props, State> {
  state: State = { error: null }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Path of Mercenaries planner render failure', error, info)
  }

  render() {
    if (!this.state.error) return this.props.children
    return (
      <main className="pp-fatal" role="alert">
        <div>
          <small>PATH OF MERCENARIES</small>
          <h1>The planner interface could not render.</h1>
          <p>No calculation was submitted. Reload the page to retry; the versioned local draft will be restored when possible.</p>
          <button type="button" onClick={() => window.location.reload()}>Reload planner</button>
          <details>
            <summary>Technical detail</summary>
            <code>{this.state.error.message}</code>
          </details>
        </div>
      </main>
    )
  }
}
